export default "__VITE_ASSET__CkFuA0Y3__"